import { graphql } from 'react-relay';

import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop-utils/entry-points/ApolloErrorInterop.ts';
import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';

import type {
	useCurrentUserContributorContentContributorsQuery$data,
	useCurrentUserContributorContentContributorsQuery$variables,
} from './__generated__/useCurrentUserContributorContentContributorsQuery.graphql.ts';

const useCurrentUserContributorContentContributorsQuery = graphql`
	query useCurrentUserContributorContentContributorsQuery($contentId: ID!) {
		contentContributors(id: $contentId) {
			isCurrentUserContributor
		}
	}
`;

type CurrentUserContributorProperties = {
	isCurrentUserContributor?: boolean;
	contentContributorsLoading: boolean;
	contentContributorsError?: ApolloErrorInterop;
};

export const useCurrentUserContributor = (contentId: string): CurrentUserContributorProperties => {
	const {
		data,
		loading: contentContributorsLoading,
		error: contentContributorsError,
	} = useQueryInterop<
		useCurrentUserContributorContentContributorsQuery$data,
		useCurrentUserContributorContentContributorsQuery$variables
	>(useCurrentUserContributorContentContributorsQuery, {
		variables: { contentId },
		skip: !contentId,
	});
	const isCurrentUserContributor: boolean | undefined =
		data?.contentContributors?.isCurrentUserContributor ?? undefined;

	return {
		isCurrentUserContributor,
		contentContributorsLoading,
		contentContributorsError,
	};
};
